module.exports = __webpack_public_path__ + "static/p-logo--futureshop-e6001c04100ffb2fcf5fa8cb0391c16f.png";